<div class="lead-status-container">
    <div *ngFor="let status of statuses; let i = index" 
         [ngClass]="getStatusClass(status)" 
         class="status-box">
      {{ status }}
    </div>
  </div>
  